<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.OPTIONS.SELECTED"
    :handler="
      async () => {
        await $nextTick();
        await $nextTick();
        await $nextTick();
        if (
          $stores.services?.state?.transactionInitiation?.operation?.id ==
          'withdraw'
        ) {
          $refs.modal.show();
          validateWithdrawAmount();
        }
      }
    "
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent
    ref="modal"
    type="bottomsheet"
    hideCloseButton
    @closed="
      ({ source }) =>
        source !== 'external' &&
        $bus.emit($constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION)
    "
  >
    <div class="flex flex-col gap-8 relative z-2">
      <form
        class="w-full gap-4"
        v-bus:EVENTS.SERVICES.INITIATION.SUBMIT_FORM.submit.prevent
      >
        <div
          class="flex flex-col gap-5 [&_input,&_select]:text-primary [&_input,&_select]:font-bold"
        >
          <label
            class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl"
            v-if="
              !$stores.services.state.transactionInitiation.bookmakerIdToUse
            "
          >
            <div class="flex flex-col px-4 col-span-4">
              <label class="mb-1 px-1">
                Votre Id
                {{
                  $stores.services.state?.transactionInitiation?.service?.name
                }}
              </label>
              <input
                v-model="
                  $stores.services.state.transactionInitiation.bookmakerId
                "
                type="number"
                required
                class="w-full px-1"
                :placeholder="`A Copier depuis l'app ${$stores.services.state?.transactionInitiation?.service?.name}`"
              />
            </div>
          </label>

          <!-- Montant -->
          <label
            class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl"
          >
            <div class="flex flex-col px-4 relative col-span-4">
              <label class="mb-1 px-1">Montant</label>
              <div class="relative flex items-center">
                <input
                  v-model="
                    $stores.services.state.transactionInitiation.senderAmount
                  "
                  type="number"
                  class="w-full px-1"
                  required
                  :min="minWithdrawAmount"
                  @input="validateWithdrawAmount"
                />
                <div class="absolute right-2">CFA</div>
              </div>
              <div v-if="withdrawAmountError" class="text-red-600 text-xs mt-1">
                {{ withdrawAmountError }}
              </div>
            </div>
          </label>

          <label
            class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl"
          >
            <div class="flex flex-col px-4 col-span-4" required>
              <label class="mb-1 pl-1 flex justify-between items-center">
                <span>
                  Téléphone
                  <span class="text-red-800 text-xs pointer-events-none">
                    {{
                      $stores.services.state.transactionInitiation
                        .mobileMoneyOperationConfigs.provider == 'none' &&
                      $stores.services.state.transactionInitiation.phoneOperator
                        ? $stores.services.state.transactionInitiation
                            .mobileMoneyOperationConfigs.launchErrorTitle
                        : ''
                    }}
                  </span>
                </span>
              </label>
              <div class="relative flex items-center">
                <input
                  v-model="
                    $stores.services.state.transactionInitiation.phoneNumber
                  "
                  required
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]{8,}"
                  class="w-full px-1"
                  :placeholder="`Ex: ${getPhoneExample($stores.user.state.current?.countryCode)}`"
                  ref="phoneNumberInput"
                />
                <div class="absolute right-2">
                  <PhoneDetail
                    :phoneNumber="
                      $stores.services.state.transactionInitiation.phoneNumber
                    "
                    :countryCode="$stores.user.state.current?.countryCode"
                    @loading="
                      (data) => {
                        $refs.phoneNumberInput.setCustomValidity('chargement');
                        $stores.services.state.transactionInitiation.phoneOperator =
                          '';
                      }
                    "
                    @resolved="
                      (data) => {
                        $refs.phoneNumberInput.setCustomValidity('');
                        $stores.services.state.transactionInitiation.phoneOperator =
                          data.carrier;
                      }
                    "
                    @error="
                      (data) => {
                        $stores.services.state.transactionInitiation.phoneOperator =
                          '';
                        $refs.phoneNumberInput.setCustomValidity(
                          `Erreur du numéro: ${data.error}`
                        );
                        /* data = { loading: false, error: 'invalid', data: null } */
                      }
                    "
                    v-slot="{ carrier }"
                  >
                    {{ $stores.services.state.transactionInitiation.isWave ? 'WAVE' : carrier }}
                  </PhoneDetail>
                </div>
              </div>
            </div>
          </label>

          <!-- Checkbox Wave pour la Côte d'Ivoire (CI) -->
          <div
            v-if="$stores.user.state.current?.countryCode === 'CI' && false"
            class="flex items-center px-5 py-3 bg-white border border-neutral-200 rounded-3xl"
          >
            <label class="flex items-center gap-3 cursor-pointer w-full select-none">
              <input
                v-model="$stores.services.state.transactionInitiation.isWave"
                type="checkbox"
                class="w-5 h-5 rounded border-neutral-300 text-primary focus:ring-primary cursor-pointer"
              />
              <span class="text-sm font-semibold text-primary">
                C'est un numéro Wave
              </span>
            </label>
          </div>

          <label
            class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl"
          >
            <div class="flex flex-col px-4 col-span-4">
              <label class="mb-1 px-1">
                code de retrait
                {{
                  $stores.services.state?.transactionInitiation?.service?.name
                }}
              </label>
              <input
                v-model.trim="
                  $stores.services.state.transactionInitiation.withdrawalCode
                "
                type="text"
                required
                class="w-full px-1"
                :placeholder="`Suivez les instructions 👇`"
              />
            </div>
          </label>
        </div>

        <!-- Bouton résumé -->
        <div class="flex flex-col gap-4 mt-4">
          <div class="p-4 rounded-xl text-white bg-primary font-black">
            <span class="uppercase">

              Adresse de retrait
            </span>
            <pre class="whitespace-pre-wrap">{{
              $stores.appData.state.data.addresses[
                $stores.user.state.current?.countryCode
              ]?.[
                $constants.SERVICES.BOOKMAKER_WITHDRAWAL_ADDRESS_KEYS?.[
                  $stores.services?.state?.transactionInitiation?.service?.id
                ]
              ] || 'Non dispnible pour le moment'
            }}</pre>
            
          </div>

          <div
            v-if="
              $stores.services?.state?.transactionInitiation?.bookmakerIdToUse
            "
            class="p-4 rounded-xl text-white bg-primary"
          >
            <div class="">
              <span>
                <ColorImg
                  class="inline-block bg-secondary w-5 h-5 -mb-1"
                  src="/images/icons/info.svg"
                  alt=""
                />
              </span>
              Nous allons retirer depuis le compte
              <span class="font-bold text-secondary">
                <BookmakerAccountDetail
                  :canChange="true"
                  :bookmaker="
                    $stores.services?.state?.transactionInitiation?.service?.id
                  "
                  :bookmakerId="
                    $stores.services?.state?.transactionInitiation
                      ?.bookmakerIdToUse
                  "
                />
              </span>
            </div>
          </div>
          <div
            v-if="tutorialVideoUrl"
            class="underline text-right pr-2 text-red-600 font-bold text-lg flex items-center justify-end gap-2 cursor-pointer"
            @click="$bus.emit($constants.EVENTS.VIDEO.PLAY, tutorialVideoUrl)"
          >
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
              />
            </svg>
            Voir comment faire un retrait
          </div>

          <!-- <div></div> -->
          <ShortSummary />

          <button
            :disabled="
              $stores.services?.state?.transactionInitiationFees?.loadingFees ||
              !!withdrawAmountError
            "
            :class="{
              'opacity-50':
                $stores.services?.state?.transactionInitiationFees
                  ?.loadingFees || !!withdrawAmountError
            }"
            class="buttonComponent w-full flex! items-center justify-center gap-2"
            type="submit"
          >
            <span> Continuer </span>
          </button>
        </div>
      </form>
    </div>
  </DialogComponent>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { ref, computed } from 'vue';
import {
  getMinAmount,
  getEffectiveMaxLimit
} from '@features/appData/limitsHelper';
import { resolveVideoLink } from '@features/appData/appDataHelper';
import { getPhoneExample } from '@features/shared/countries';

const { proxy } = getCurrentInstance();

const { $stores } = proxy;

const withdrawAmountError = ref(null);

const minWithdrawAmount = computed(() => {
  const serviceId = $stores.services?.state?.transactionInitiation?.service?.id;
  const countryCode = $stores.user?.state?.current?.countryCode;
  if (!countryCode) return 0;
  return getMinAmount(countryCode, 'withdraw', serviceId);
});

const maxWithdrawAmount = computed(() => {
  const serviceId = $stores.services?.state?.transactionInitiation?.service?.id;
  const countryCode = $stores.user?.state?.current?.countryCode;
  if (!countryCode) return Infinity;
  return getEffectiveMaxLimit(countryCode, 'withdraw', serviceId);
});

const tutorialVideoUrl = computed(() =>
  resolveVideoLink($stores.appData?.state?.data, {
    serviceId: $stores.services?.state?.transactionInitiation?.service?.id,
    operation: $stores.services?.state?.transactionInitiation?.operation?.id,
    countryCode: $stores.user?.state?.current?.countryCode
  })
);

function validateWithdrawAmount() {
  const amount = parseFloat(
    $stores.services.state.transactionInitiation.senderAmount
  );
  const min = minWithdrawAmount.value;
  const max = maxWithdrawAmount.value;

  if (!amount || amount < min) {
    withdrawAmountError.value = `Le montant minimum de retrait est de ${min} CFA`;
  } else if (max !== Infinity && amount > max) {
    withdrawAmountError.value = `Le montant maximum de retrait est de ${max} CFA`;
  } else {
    withdrawAmountError.value = null;
  }
}

validateWithdrawAmount();
</script>
